import React from 'react'

import { Cross2Icon } from '@radix-ui/react-icons'
import { tx } from '@twind/core'

const HorizontalSelect = (props: {
  label: string
  hideLabel?: boolean
  options: (string | { key: string; label: string })[]
  selected: string[]
  onChangeValue: (_value: string[]) => void
}) => {
  const { label, hideLabel, options, selected, onChangeValue } = props

  const handleOnClick = (item: string, isSelected: boolean) => {
    if (isSelected) onChangeValue(selected.filter((el) => el !== item))
    else onChangeValue([...selected, item])
  }

  return (
    <div className="flex items-center whitespace-nowrap">
      <div className={tx('py-2 px-3', hideLabel && 'sr-only')}>{label}</div>

      <div className="flex overflow-x-auto">
        {options &&
          options.map((item) => {
            const isString = typeof item === 'string'
            const key = isString ? item : item.key
            const isSelected = selected.includes(key)

            return (
              <div
                key={key}
                className={tx(
                  'z-10 relative flex align-center items-center py-1 px-3 capitalize rounded my-2 mx-1 text-sm transition-colors cursor-pointer border-1 border-zinc-600 hover:border-zinc-400',
                  isSelected && 'border-primary hover:border-primary'
                )}
                onClick={() => handleOnClick(key, isSelected)}>
                {isString ? item : item.label}
                {isSelected && (
                  <span className="ml-2">
                    <Cross2Icon />
                  </span>
                )}

                <span
                  className={tx(
                    'absolute w-full h-full top-0 left-0 rounded opacity-30 z-[-1]',
                    isSelected && ' bg-primary'
                  )}
                />
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default HorizontalSelect
